import { Injectable, Inject } from '@angular/core';
import { EnvModel } from './environment.model';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class EnvironmentService {
    public envModel: EnvModel;
    public envModelNull: EnvModel = null;


    constructor(private http: HttpClient, @Inject('Window') private _window: Window) { }

    public loadEnvironment(): Observable<EnvModel> {

        if (this.envModel === null || this.envModel === undefined) {
            return this.http.get<EnvModel>(this.getUrlEnv()).pipe(
                map((res: EnvModel) => {
                    if (res) {
                        this.envModel = res;
                        return this.envModel;
                    } else {
                        console.error("enviroment null");
                        return null;
                    }
                }),
                catchError((err) => {
                    console.error("Erro ao recuperar enviroment", err);
                    return of(this.envModelNull);
                }));
        } else {
            return of(this.envModel);
        }
    }

    private getUrlEnv(): string {
        let routeEnv = '';
        if (this._window.location.hostname.indexOf("ww73hom.itau") > -1) {
            routeEnv += './assets/environment/env.hom.json'
        }
        else if (this._window.location.hostname.indexOf("ww73.itau") > -1 || this._window.location.hostname.indexOf("investmentservices") > -1) {
            routeEnv += './assets/environment/env.prod.json'
        }
        else if(this._window.location.hostname.indexOf("localhost") > -1 || this._window.location.hostname.indexOf("web-jboss-en4-securitiesservices.ctsp.des") > -1 ) {
            routeEnv += './assets/environment/env.json'
        }
        return routeEnv;
    }


    public setEnvModel(es: EnvModel) {
        if (es === null || es === undefined) {
            return;
        }

        this.envModel = es;
    }
}
